import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  deviceId: null,
};

const deviceSlice = createSlice({
  name: "device",
  initialState,
  reducers: {
    setDeviceId: (state, action) => {
      state.deviceId = action.payload;
    },
  },
});

export const { setDeviceId } = deviceSlice.actions;
export default deviceSlice.reducer;
